import Page from '@/features/Services/pages/Cookie'

export default Page
